import {
	type GoalPortfolioResponseDTO,
	GoalPortfolioTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const getGoalPortfoliosByType = (
	portfolios: GoalPortfolioResponseDTO[],
) => ({
	allocated: portfolios.filter(
		(portfolio) => portfolio.type === GoalPortfolioTypeEnum.Allocated,
	),
	setAside: portfolios.filter(
		(portfolio) => portfolio.type === GoalPortfolioTypeEnum.SetAside,
	),
});
